export default {
  dashboardv2: {
    usersByStatus: "Utenti per Stato",
    allTime: "Tutto il tempo",
    noOfUsers: "No. degli utenti",
    usersByGender: "Utenti Per genere",
    gender: "Genere",
    farmerName: "Nome del coltivatore",
    farmerProduction: "Produzione agricola",
    production: "Produzione",
    plan: "Piano",
    expiryDate: "Data di scadenza",
    buyingStationProduction: "Produzione della stazione di acquisto",
    dryMillingProduction: "Produzione di fresatura a secco",
    usersPerMembershipPlans: "Utenti Per Piani di Membership",
    planType: "Tipo di piano",
    users: "Utenti",
    planValidity: "Piani di validità",
    averageSellingPriceByAllFarmers:
      "Prezzo di vendita medio da tutti gli agricoltori",
    avgSellingPrice: "Avg. Prezzo di vendita",
    pricePaid: "Prezzo pagato",
    avgSellingPricePerFarmer: "Prezzo medio di vendita per agricoltore",
    exportAsCSV: "Esportazione come CSV",
    exportAsXLS: "Esportazione come XLS",
    filterByFarm: "Filtra per aziende agricole",
    searchFarms: "Ricerca agriturismi",
    filterByRegion: "Filtra per Regione",
    filterByFarmer: "Filtra per contadino",
  },

  dashboardSection: {
    greenBeansData: "Gestione dei fagioli verdi",
    dryMilling: "Mulino a secco",
    modules: "Moduli",
    allowances: "Consentizioni",
    maxUserAllowed: "Max utenti ammessi",
    satelliteReportsAllowed: "Report satellitari ammessi",
    advanceReport: "Rapporti avanzati consentiti",
    subscriptionUpTo: "Abbonamento Fino a",
    roleAllowed: "Ruoli ammessi",
    moduleAllowed: "Moduli ammessi",
    registeredUsers: "Utenti registrati",
    validMemberships: "Abbonamenti validi",
    activeUsers: "Utenti attivi",
    deactivatedUsers: "Utenti disattivati",
    membershipValidity: "Validità degli iscritti",
    lessThan1Month: "Meno di 1 mese",
    months1to6: "1-6 mesi",
    months6to12: "6-12 Mesi",
    moreThan1Year: "Più di 1 anno",
    cropOverview: "Panoramica del raccolto",
    buySellOverview: "Acquisto/vendita",
    plantations: "Piante",
    coffeeData: "Dati del caffè",
    availableModules: "Moduli disponibili",
    roleList: "Farmer, Stazione di acquisto, Magazzino",
    memberData: "Dati dei membri",
    userType: "Tipo utente",
    registered: "Registrato",
    offlineUsers: "Utenti offline",
    lessThanOneMonth: "< 1 mese",
    cacaoData: "Dati Cacao",
    dryCacao: "Dre Cacao",
    traceability: "Tracciabilità",
    allFarm: "Tutti gli agriturismi",
  },
  dashboardReports: {
    appDataReports: "Rapporti sui dati dell'app",
    reports: "Relazioni",
  },
  countries: "Paesi",
};
